//任何的小仓库都需要:state、mutations、actions、getters 
//仓库存储数据的地方
let state = {
    newMian: [],
}
//仓库计算属性
let getters = {};

//唯一可以修改仓库数据地方
let mutations = {
    NEWMIAN(state, res) {
        if (res) {
            if (!state.newMian.includes(res)) {
                state.newMian.push(res)
            }
        }
    },
    DELMIAN(state, res) {
        if (res) {
            state.newMian = state.newMian.filter(item => item !== res)
        }
    }

}

let actions = {}
//对外暴露小仓库
export default {
    // 开启命名空间
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
}